export default __webpack_public_path__ + "static/media/gallery4.039d2e1b.JPG";